import { createVanIconComponent } from "./van"

const PointGiftOutlined = createVanIconComponent("point-gift-o")
export default PointGiftOutlined
